// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2oYky","colBig":"styles_colBig__26mge","colSmall":"styles_colSmall__k294E"};